import React from 'react';
import Hero from '../components/Hero';
import Founder from '../components/Founder';
import Features from '../components/Features';
import Process from '../components/Process';
import LeadForm from '../components/LeadForm';
import FAQ from '../components/FAQ';

export default function Home() {
  return (
    <>
      <Hero />
      <Founder />
      <Features />
      <Process />
      <LeadForm />
      <FAQ />
    </>
  );
}